import { GET_SLOTS_DATA , GET_BOARDING_PATTERN_DATA, GET_GUEST_COUNT} from './../constants/actionTypes'

export const getSlots = (data, shipTime) => dispatch => {
  dispatch({
    type: GET_SLOTS_DATA,
    data,
    shipTime
  })
}

export const getBoardingPatternDataAction = (data, shipTime) => dispatch => {
  dispatch({
    type: GET_BOARDING_PATTERN_DATA,
    data,
    shipTime
  })
}

export const getGuestCount = (data) => dispatch => {
  dispatch({
    type: GET_GUEST_COUNT,
    data
  })
}

